const authProvider = {
    login: async ({ username, password, captcha }) =>  {
        const request = new Request('https://www.muttinservice.it/authenticate', {
            method: 'POST',
            mode: "cors", // no-cors, *cors, same-origin
            body: JSON.stringify({ username, password, captcha }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error("Username/password non corretti o captcha incorretto");
                }
                return response.json();
            })
            .then(auth => {
                localStorage.setItem('auth', JSON.stringify(auth));
            })
            .catch((e) => {
                throw new Error(e)
            });
    },
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('auth');
            return Promise.reject({ message: 'Utente non autorizzato' });
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
    },
    checkAuth: () => (
        // Required for the authentication to work
        localStorage.getItem('auth')
        ? Promise.resolve()
        : Promise.reject({message: 'Necessario il login'})
        /* when the promise is rejected we can redirect the user in a page different 
        from the default, otherwise it will be sent to /login ex.
        Promise.reject({ redirectTo: '/no-access'}) */
    ),
    getPermissions: () => {
        // Required for the authentication to work
        return Promise.resolve();
    },
    logout: () => {
        /* we can notify here to the backend that the credentials used are not longer valid */
        localStorage.removeItem('auth');
        return Promise.resolve();
    },
    // ...
};

export default authProvider;